<template>
    <div class="form-actions" :class="classList">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'FormActions',
    props: {
        'align' : String,
    },
    computed: {
        classList () {

            let classList = '';
            classList += this.align ? ' form-actions--align-' + this.align : '';

            return classList;
        },
    },
};
</script>
